import React from 'react';
import { FadeIn } from './FadeIn';
import { Badge } from './Badge';
import { motion } from 'framer-motion';
import { Separator } from './Separator';
export function Bonus2Section() {
  return <section className="py-12 md:py-16 bg-stone-950 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-71">
      <div className="max-w-6xl mx-auto" data-id="element-72">
        {/* SECCIÓN 4 — SEPARADOR */}
        <FadeIn className="max-w-3xl mx-auto text-center mb-12" data-id="element-73">
          <p className="text-xl md:text-2xl text-stone-300 leading-relaxed italic" data-id="element-74">
            "Y si el protocolo te da la herramienta para soltar el
            pensamiento...{' '}
            <strong className="text-amber-400 not-italic" data-id="element-75">
              el bono te da el mapa para saber exactamente qué estás soltando.
            </strong>
            "
          </p>
          <Separator className="mt-12 bg-stone-800 max-w-xs mx-auto" data-id="element-76" />
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-77">
          <FadeIn direction="right" className="flex justify-center" data-id="element-78">
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            repeat: Infinity,
            duration: 5,
            ease: 'easeInOut',
            delay: 0.5
          }} className="relative w-full max-w-[200px] md:max-w-[260px] perspective-[1000px]" data-id="element-79">
              <div className="absolute inset-0 bg-amber-500/20 blur-[60px] rounded-full" data-id="element-80" />
              <motion.img whileHover={{
              rotateY: 5,
              rotateX: 5,
              scale: 1.02
            }} transition={{
              duration: 0.4
            }} src="https://cdn.magicpatterns.com/uploads/o5fruLTcPigRuz58Vvu67A/bono2mapa.png" alt="Mapa de Pensamientos Nocturnos" className="relative w-full h-auto rounded-xl shadow-[0_20px_50px_-12px_rgba(217,119,6,0.25)] border border-stone-700/50" style={{
              transformStyle: 'preserve-3d'
            }} data-id="element-81" />
            </motion.div>
          </FadeIn>

          <FadeIn direction="left" delay={0.2} data-id="element-82">
            <Badge className="bg-amber-500/20 text-amber-400 hover:bg-amber-500/30 mb-6 px-4 py-1.5 text-sm border-amber-500/30" data-id="element-83">
              Valor:{' '}
              <span className="line-through mx-1 text-stone-500" data-id="element-84">$13 USD</span>{' '}
              → Hoy GRATIS
            </Badge>

            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 leading-tight" data-id="element-85">
              <span className="text-lg block mb-1" data-id="element-86">🎁 BONO #1</span>
              MAPA DE PENSAMIENTOS NOCTURNOS
            </h2>

            <div className="space-y-4 text-base text-stone-300 leading-relaxed" data-id="element-87">
              <p className="font-medium text-stone-200" data-id="element-88">
                Identifica en segundos qué tipo de pensamiento te está robando
                el sueño y qué hacer con él sin sobrepensarlo más.
              </p>

              <ul className="space-y-2 my-4 pl-2 text-sm" data-id="element-89">
                <li className="flex items-start gap-3" data-id="element-90">
                  <span className="text-amber-500 mt-1" data-id="element-91">✦</span>
                  <span data-id="element-92">
                    <strong className="text-white" data-id="element-93">Pendiente operativo</strong>{' '}
                    → cómo registrarlo sin seguir repasándolo
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-94">
                  <span className="text-amber-500 mt-1" data-id="element-95">✦</span>
                  <span data-id="element-96">
                    <strong className="text-white" data-id="element-97">
                      Conversación repetitiva
                    </strong>{' '}
                    → cómo cortar el bucle social sin censurarte
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-98">
                  <span className="text-amber-500 mt-1" data-id="element-99">✦</span>
                  <span data-id="element-100">
                    <strong className="text-white" data-id="element-101">Catástrofe futura</strong> →
                    cómo reconocerla sin intentar resolverla de noche
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-102">
                  <span className="text-amber-500 mt-1" data-id="element-103">✦</span>
                  <span data-id="element-104">
                    <strong className="text-white" data-id="element-105">
                      Revisión del pasado / culpa
                    </strong>{' '}
                    → cómo cerrarla sin reabrirla
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-106">
                  <span className="text-amber-500 mt-1" data-id="element-107">✦</span>
                  <span data-id="element-108">
                    <strong className="text-white" data-id="element-109">
                      Ruido amplificado por cansancio
                    </strong>{' '}
                    → cómo bajarle la credibilidad nocturna
                  </span>
                </li>
              </ul>

              <p data-id="element-110">
                Incluye tabla visual, scripts de cierre rápido y hoja resumen
                printable para tener junto a la cama.
              </p>

              <div className="pt-4 border-t border-stone-800" data-id="element-111">
                <p className="text-emerald-400 font-semibold" data-id="element-112">
                  Valor: $13 USD — Incluido GRATIS hoy
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}